import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    width: '100%',
    height: '250px',
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '17px',
    justifyContent: 'space-around',
  },
  labelContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  accuracy: {
    marginRight: '8px',
    marginLeft: '8px',
    width: '216px',
    flexDirection: 'row',
  },
  rectangle: {
    width: '40px',
    height: '12px',
    marginRight: 4,
    ':last-child': {
      marginRight: 0,
    },
  },
  grade: {
    flexDirection: 'row',
    paddingRight: '68px',
    justifyContent: 'flex-end',
  },
  rank: {
    display: 'inline-block',
    width: 40,
    height: 10,
    textAlign: 'center',
    verticalAlign: 'middle',
    marginRight: '4px',
  },
  number: {
    width: 31,
    marginRight: 33,
  },
  grade1: {
    backgroundColor: '#8C9BC1',
  },
  grade2: {
    backgroundColor: '#ABB5AE',
  },
  grade3: {
    backgroundColor: '#C7BF74',
  },
  grade4: {
    backgroundColor: '#E3C839',
  },
  grade5: {
    backgroundColor: '#FFD102',
  },
  gray: {
    backgroundColor: '#405C9A',
  },
  percentBlue: {
    position: 'absolute',
    backgroundColor: '#405C9A',
    height: '12px',
  },
  labelName: {
    width: 72,
  },
});



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/accuracy_table/styles.js